<template>
  <DefaultResult :result="result" :highlight="true">
    <template v-slot>
      <div class="p-6">
        <div class="flex items-start space-x-4 lg:space-x-6">
          <figure v-if="result.poster" class="w-1/3 shrink-0 border border-gray-200 rounded-md">
            <img :src="result.poster" alt="" class="rounded-md">
          </figure>

          <div class="flex-1">
            <p v-if="result.location" class="mb-2 flex items-center text-sm font-semibold text-gray-700">
              <svg-icon name="map-pin-fill" classes="w-5 h-5 mr-1.5 text-teal-600" />
              {{ result.location }}
            </p>

            <h3 class="mb-1 text-2xl">
              <a :href="result.url" class="text-blue-700 no-underline hover:underline">
                <ais-highlight :hit="result" attribute="title" highlightedTagName="mark"></ais-highlight>
              </a>
            </h3>

            <p v-if="result.subtitle" class="mb-1 font-semibold text-gray-800">{{ result.subtitle }}</p>

            <p class="mb-0 text-gray-700">
              <ais-snippet v-if="result.content" :hit="result" attribute="content" highlightedTagName="mark">
              </ais-snippet>
            </p>

            <p v-if="result.price" class="mb-0 mt-2 text-lg font-bold text-teal-600">{{ result.price }}</p>
          </div>
        </div>

        <div class="mt-4 border-t border-gray-200 pt-4">
          <div v-if="upcoming.length" class="flex flex-wrap items-center gap-2">
            <span class="text-xs font-bold uppercase tracking-widest text-gray-700">
              {{ upcoming.length }} Upcoming class{{ upcoming.length > 1 ? 'es' : '' }}
            </span>
            <a v-for="occurrence in upcoming.slice(0, 3)" :key="occurrence.url" :href="occurrence.url" target="_blank"
              class="rounded-full border-[1.5px] border-green-200 px-3 py-1 text-sm font-bold text-green-500 no-underline transition-colors hover:border-green-500">
              {{ formatDate(occurrence.date) }}
            </a>
            <a v-if="upcoming.length > 3" :href="result.url"
              class="px-1 py-1 text-sm font-bold text-green-500 no-underline hover:underline">
              +{{ upcoming.length - 3 }} more &rarr;
            </a>
          </div>

          <p v-else class="mb-0 text-xs font-bold uppercase tracking-widest text-gray-700">
            No dates scheduled
          </p>
        </div>
      </div>
    </template>
  </DefaultResult>
</template>

<script>
import {
  AisHighlight,
  AisSnippet
} from 'vue-instantsearch/vue3/es'
import DefaultResult from '@js/components/search/results/DefaultResult.vue'
import SvgIcon from '@js/components/SvgIcon.vue'

export default {
  props: ['result'],

  components: {
    AisHighlight,
    AisSnippet,
    DefaultResult,
    SvgIcon
  },

  computed: {
    // The index can go stale between reindexes, so drop dates that have passed
    upcoming() {
      const now = Date.now()
      return (this.result.occurrences ?? []).filter(occurrence => occurrence.date * 1000 >= now)
    }
  },

  methods: {
    formatDate(timestamp) {
      return new Date(timestamp * 1000).toLocaleDateString('en-us', { year: 'numeric', month: 'short', day: 'numeric' })
    }
  }
}
</script>
